import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { cloneDeep } from "lodash";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { containerTraversal } from "../../actionHelpers/containerTraversal";
import { IWebsiteBuilderSectionEntityStretch } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderSectionEntity";

export interface IUpdateContainerStretchActionPayload {
  id: string;
  prevStretch: IWebsiteBuilderSectionEntityStretch;
  nextStretch: IWebsiteBuilderSectionEntityStretch;
}

export interface IUpdateContainerStretchAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.UPDATE_CONTAINER_STRETCH;
  payload: IUpdateContainerStretchActionPayload;
}

export function getUpdateContainerStretchInverseAction(action: IUpdateContainerStretchAction): IUpdateContainerStretchAction {
  const { id, nextStretch, prevStretch } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.UPDATE_CONTAINER_STRETCH,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevStretch: cloneDeep(nextStretch),
      nextStretch: cloneDeep(prevStretch),
    },
  };
}

export function applyUpdateContainerStretchChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IUpdateContainerStretchAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, nextStretch } = action.payload;

  return containerTraversal(header, root, footer, id, {
    stretch: cloneDeep(nextStretch),
  });
}